module.exports = __webpack_public_path__ + "assets/images/amountofPaintings-02.6b616f46af710b236cc722c4e890b5d1.svg";